import { useCallback } from 'react';

export const appendToTracking: { anti_sharing_ready: boolean; anti_sharing: Record<string, any> } =
  {
    anti_sharing_ready: false,
    anti_sharing: {},
  };

export function useAppendToAntiSharingTracking() {
  const setAntiSharingTracking = useCallback((tracking: Record<string, any>) => {
    appendToTracking.anti_sharing = { ...appendToTracking.anti_sharing, ...tracking };
    appendToTracking.anti_sharing_ready = true;
  }, []);
  return setAntiSharingTracking;
}
